export enum FeatureFlags {
  UserClaimServiceSkipPhoneVerification = 'user-claim-service-skip-phone-verification',
  WebSearchOverhaul = 'web-search-overhaul',
  TestMobileOperation = 'test-mobile-fe-operation',
  isFixedIncomeEnabled = 'fixed-income-ui',
  isFeesAndCommissionsEnabled = 'fees-and-commissions-ui',
}

export type FeatureFlagsType = Record<FeatureFlags, boolean>;
